import { render } from "./OpenShift.vue?vue&type=template&id=28af6bf7&scoped=true"
import script from "./OpenShift.vue?vue&type=script&lang=js"
export * from "./OpenShift.vue?vue&type=script&lang=js"

import "./OpenShift.vue?vue&type=style&index=0&id=28af6bf7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28af6bf7"]])

export default __exports__